import axios from 'axios'
import { ExpensePolicyResponse } from 'src/models/organizations.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getExpensePolicy = async (
  orgId: string,
): Promise<ExpensePolicyResponse> => {
  return getResponseData(
    axios.get<ExpensePolicyResponse>(
      `/organizations/${orgId}/expensepolicy`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
